import { Box } from '@mui/system';
import PriceCardFAQ from './PricingCardFAQ';
import PricingCardShareHolder from './PricingCardShareHolder';
const PricingCardShareHolderWithFAQ = ({ data, onHandleClickPlan, selectedShareholderValue }) => {
    return (
        <Box display={'flex'} gap={3} flexDirection={'column'}>
            <PricingCardShareHolder
                defaultSelectValue={selectedShareholderValue || data?.menuListSelection?.default.value}
                handleChange={onHandleClickPlan}
                selectLists={data?.menuListSelection?.lists || []}
                shareHolderDescription={data?.subTitle}
                shareHolderTitle={data?.headingToShow}
                textAfterSelect={data?.textAfterButton}
            />
            <PriceCardFAQ
                faqLink={data?.faqs?.link || ''}
                faqSubTitle={data?.faqs?.subTitle || ''}
                faqTitle={data?.faqs?.title || ''}
                faqlist={data?.faqs?.lists}
                linkDirection={data?.faqs?.linkDirection}
            />
        </Box>
    );
};
export default PricingCardShareHolderWithFAQ;
